import useApp from "./useApp";

import { useNavigate } from "react-router-dom";

function useRequestError() {
  const navigate = useNavigate();
  const { messageProps } = useApp();

  const updateMessageModal =
    typeof messageProps?.updateMessageModal === "function"
      ? messageProps?.updateMessageModal
      : () => {
          console.warn("Update message props not a function");
        };

  return (e) => {
    if (e?.message === "Network Error") {
      updateMessageModal({
        isVisible: true,
        header: "Network Error",
        message: "Check your internet connection",
        headerBg: "red",
      });

      return;
    }

    const message =
      e?.response?.data?._message || e?.response?.data?.message || "-";

    if (e?.response?.status === 401) {
      if (e?.response?.data?.custom) {
        updateMessageModal({
          isVisible: true,
          header: "Unothorized",
          message: message,
          headerBg: "red",
        });
      }
      navigate("/");
      return;
    }

    if (e?.response?.data?.custom) {
      updateMessageModal({
        isVisible: true,
        header: "Client Error",
        message: message,
        headerBg: "red",
      });
      return;
    }

    updateMessageModal({
      isVisible: true,
      header: "Server Error",
      message: "Contact System Admin",
      headerBg: "red",
    });
  };
}

export default useRequestError;
